import Vue from 'vue';

import { date } from './date';
import { carImage } from './car-image';
import { yuan } from './yuan';

Vue.filter('date', date);
Vue.filter('carImage', carImage);
Vue.filter('yuan', yuan);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/filters/index.ts